import { ReactNode, useMemo } from 'react';
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { useCiam } from './CiamProvider';

type Props = { children: ReactNode };

export const ApiProvider = ({ children }: Props) => {
  const { apiUrl, token } = useCiam();

  const client = useMemo(() => {
    const link = new HttpLink({
      uri: apiUrl + 'graphql',
      fetch: (...args) => fetch(...args),
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    return new ApolloClient({
      link,
      cache: new InMemoryCache({
        typePolicies: {
          Query: {
            fields: {
              searchCiamUsers: relayStylePagination(['parameters']),
            },
          },
        },
        addTypename: false,
      }),
    });
  }, []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
